import {
    Text,
    View,
    StyleSheet,
} from "@react-pdf/renderer";
import moment from 'moment';
import { DataEmployee } from "../../../router/pdfdownload";
const styles = StyleSheet.create({
    textlg: {
        fontFamily: 'Open Sans',
        fontSize: 18,
        fontWeight: 600
    }, textmd: {
        fontSize: 16
    },
    textsm: {
        fontSize: 14
    },
    textxs: {
        fontSize: 12
    }, headersection: {
        flexDirection: "row",
        fontSize: 14
    },
    headervalue: {
        marginLeft: 20
    },
    headertitle: {
        marginVertical: 4,
        minWidth: 110
    }
})
export default function TableHeader(data : DataEmployee) {
    const datenow = moment().format("DD MMM YYYY");
    const date1 = moment(data.dateFrom).format("DD MMM YYYY") || "";
    const date2 = moment(data.dateTo).format("DD MMM YYYY") || ""
    return (
    <>
        <View>
            <Text style={[styles.textmd, { textAlign: "center", marginVertical: 10, marginBottom: 30 }]}>SLIP GAJI KARYAWAN</Text>
        </View>
        <View style={styles.headersection}>
            <Text style={styles.headertitle}>Tanggal</Text>
            <Text style={styles.headervalue}>: {datenow.toString()}</Text>
        </View>
        <View style={styles.headersection}>
            <Text style={styles.headertitle}>Nama Karyawan</Text>
            <Text style={styles.headervalue}>: {data.name || ""}</Text>
        </View>
        <View style={styles.headersection}>
            <Text style={styles.headertitle}>Periode</Text>
            <Text style={styles.headervalue}>: {date1} - {date2}</Text>
        </View></>
        )
    }